// DS: CR59
/** An image link in card form that displays art and title
 *  associated with a _popular_ topic.
 */
import React from 'react';
import classnames from 'classnames';
import Heading from '../a11y/headings/Heading';
import { BiLink, BiEventType } from '../biLogger';
import DeviationDumbo from '../DeviationViews/Dumbo';
import s from './TopTopicCard.scss';
var TopTopicCard = function (props) {
    var url = props.url, name = props.name, deviation = props.deviation, width = props.width, className = props.className, typeId = props.typeId, itemId = props.itemId, rank = props.rank;
    if (!url || !name || !width) {
        return null;
    }
    var classNames = classnames(s.root, className, !deviation && s['missing-bg']);
    var linkStyles = { width: width };
    return (React.createElement(BiLink, { href: url, style: linkStyles, className: classNames, biData: {
            evid: BiEventType.ITEM_CLICK,
            typeid: typeId,
            itemid: itemId,
            rank: rank,
        } },
        React.createElement(Heading, { className: s['name'] }, name),
        deviation && (React.createElement(DeviationDumbo, { className: classnames(s["cover"]), deviation: deviation, width: width }))));
};
TopTopicCard.displayName = 'TopTopicCardCR59';
export default TopTopicCard;
//# sourceMappingURL=TopTopicCard.js.map